
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Clear`,
'deleteKey': `⌦ Изтриване`,
'downKey': `↓ надолу`,
'endKey': `⤓ Край`,
'enterKey': `Въведете`,
'escapeKey': `⎋ Бягство`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Генериране на 
          <code>LICENSE 
          </code> файл 
        `,
'homeKey': `⤒ Начало`,
'keyCommand': `⌘ Команда/Win`,
'keyControl': `^ Контрол`,
'keyOption': `⌥ Опция/Алт`,
'keyShift': `⇧ Смяна`,
'leftKey': `← Ляво`,
'pagedownKey': `▼ Пагедане`,
'pageupKey': `▲ Страница нагоре`,
'rightKey': `→ Право`,
's00065e45db8c0441': `Вижте Инструменти за разработчици за повече информация`,
's001dd78415a91fa0': `Улей на лентата за превъртане`,
's002fa7d1054ed082': `Гранично поле`,
's006f872a5b7f5279': `Сангро`,
's01b16a926920908b': `Казахски`,
's01b56d233c6c5cac': `Разделяне на секции`,
's01d32b35baa3b676': `Автор`,
's02106cc2ef0e7578': `Нов щифт...`,
's02ab1ea8e5100fc1': `Маркиране на избора като "двупосочно отменяне`,
's0312976fe9da5951': `Бутон`,
's03608a32f05eded2': `Притискане на мащаба`,
's036d35e03be98d22': `Математическа дълбочина`,
's037b1dc850a89273': `Алтернатива под`,
's0396202b716732ec': `Маркирайте избора като пробит`,
's03f49e598ffb11cc': `Полски`,
's0448f1059fa01720': `Запазете, споделете или разпечатайте проучваното от вас. Редактирайте информация, като например заглавие, език или лиценз.`,
's0458872c43beadef': `Вмъкване на ред преди`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Разстояние между думите`,
's05e9759cfd99c48f': `Оправдайте`,
's063fa5a0a4903bf4': `Встрани, от ляво на дясно`,
's064339c229374050': `Кодиране`,
's06634274f19b0572': `Избор на щифт`,
's06743b24499f0035': `Център за закрепване`,
's07808b0ca6da8fef': `Ограден уебсайт`,
's07970793b21351fd': `Базов контейнер на Ruby`,
's079cf7850d9327f0': `Шрифт`,
's07aa10850d9ddcc7': `Формуляр`,
's07e6118e838b2e23': `Навигация`,
's0816468df86e4036': `Отваря настройките`,
's082869038c117fe5': `Португалски (Бразилия)`,
's086e6c267ade2609': `Насищане`,
's08e12ade32ef8125': `Сетсвана`,
's08e6bd98452e6bb9': `Аудио`,
's0978fb5ba3145996': `Вмъкване на списък (без подредба)`,
's09c3f1d21de14ae1': `Маркирайте селекцията като подчертана`,
's0a2d91c6720033e9': `Подрязване на разстоянието между текстовете`,
's0a3ddcba94027d95': `Прилягане на обекта`,
's0a6cb8d42cdb0c4a': `Есперанто`,
's0a799f583098cadf': `Вмъкване на навигация`,
's0a7db790db1fc45c': `Маркирайте селекцията като обхват`,
's0b1271f50a77dc73': `Кутия за съдържание`,
's0b24d08ea349b455': `Всичко, което можете да вмъкнете. В началото са неинтерактивни елементи като списъци или изображения, а след това са интерактивни елементи, наречени уиджети. Можете да получите нови такива, като щракнете върху лентата за търсене.`,
's0bdca49248ba4820': `Преки пътища`,
's0befccf152b6c0a9': `Ориент от метаданни`,
's0c11e479416c8421': `Вмъкване на надпис на таблица`,
's0c27336067c59611': `Подложка за превъртане`,
's0c4593d81f147042': `Базова линия`,
's0c4b2e98d4ab7f5a': `Команди за приложения`,
's0c883713b83616a8': `Запазване на активния документ`,
's0ca5c0460199cba1': `Съкращение`,
's0cf10c4f40588f8d': `Заглавие на таблицата`,
's0d86afa3c6a1e28b': `Посока на гъвкавост`,
's0dad143dff0079fc': `Малаялам`,
's0db05bd7ba6fff96': `Вашият документ за проучване. Тук можете да пишете текст, да копирате/вмъквате, да редактирате и т.н.`,
's0dc452999c129e15': `Активиране на презареждане в реално време`,
's0de0febab8a4beaf': `Грешка при четене на този пакет`,
's0e44968489e076a8': `Китайски`,
's0e4862e87c7d53ce': `Маркирайте избора като цитат`,
's0e6ea8870dbddab2': `Команди за документи`,
's0ee28503778e4c0c': `Последна базова линия`,
's0ef01c03299bbb83': `Декорация`,
's0f17f32919661cff': `Монголски`,
's0f350bc4e538e3ea': `Думи`,
's105a06836c40fcb4': `Задаване на филтри, цвят и смесване на избраните елементи`,
's106b274b5af798e5': `Изречения`,
's1082e1649793dca9': `Маркирайте избора като дефиниран термин`,
's10f3845975a0351e': `Редактиране на метаданни`,
's1125d159f7e64df5': `Дисплей`,
's11326fd2590f4e5e': `По подразбиране`,
's1155ec07a221e739': `Лентата за превъртане`,
's1173bf7a3e0b74c9': `Минимален (y)`,
's1177237a3e0e548c': `Минимален (x)`,
's1219d97b49650c05': `Видимост`,
's123bea44f38abccf': `Вмъкване на обект`,
's1245e2cb9f20197e': `Изравняване на`,
's12946ec1b850962c': `Вмъкване на колона след`,
's1351209ef74ee729': `Обхващане на всички колони`,
's13c60cb409e8cb6f': `Изравняване на центъра`,
's13ebd619c8a06a6d': `Автоматични редове в решетката`,
's13ef8ca26ca8861b': `Изрязан елемент`,
's151bc2eea7a032a4': `-променен-`,
's153bc3c3aa39587b': `Глава на маса`,
's156647179b21d351': `Вмъкване на тяло на таблица`,
's158b6ec6b1fffcb2': `Прекъсване след`,
's15d0c0657c1ee08c': `Ключ за API`,
's1626a7e10a9f9dcc': `Задава фамилията на шрифта на селекцията`,
's1637c7d1a30629e2': `Гранично поле`,
's1641ab440bf4daa4': `Актуализиране на този пакет с джаджи`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Напреднали: Показване на пакети с версии като 0.x.x в мениджъра на пакети`,
's16b9446e3a70e1f4': `Атрибути`,
's16f205466761e583': `Без оптично оразмеряване на шрифта`,
's16f2f1c2c516d307': `Отваряне на документ`,
's1749014f3f87fa6a': `Стреч`,
's17597a8bb4810524': `Лиценз`,
's17bfaaa4e7528bc7': `Башкирия`,
's17fb3f4805f4f4b9': `Премахване на полето`,
's181ef198cf83ec3a': `Бихари`,
's1857db526dc4dcdd': `Създаване на пакет`,
's18d5c44aae3dc82a': `Онлайн при редактиране`,
's1988d71ef8060edf': `Вмъкване на ред от таблица`,
's19abee1277c9bca2': `Самоански`,
's19daf2f26c19543d': `Контур`,
's1a1acc902e6668e0': `Показване на разширено форматиране на текст`,
's1a5230a71d9285c1': `Улавяне`,
's1aa1cb63ad44bc6f': `Разлика между колоните`,
's1af8b67d1c85c811': `Пространство между`,
's1b4a36fce2456660': `Семейство шрифтове`,
's1c246045629b0016': `Маркиране на избора като изтриване`,
's1c3fc313a9184670': `Публична връзка`,
's1c65f5004a07dcfa': `Шотландски гаелски`,
's1c690963f1e2df00': `Специфичен за платформата вид`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Искате кратка обиколка с екскурзовод?`,
's1d19244f549ec535': `Образование`,
's1d5c7b28e8b50d6d': `Асоциирана степен.`,
's1db591f5a54dbfd3': `Кутия за съдържание`,
's1dbb9f50e16c92a3': `Радиус на границата`,
's1dfb744260fb3a01': `Двупосочна изолация`,
's1e9c2c654732cc5f': `Белоруски`,
's1eaccbf2d6af8ab5': `Информация`,
's1efbfc3937d565bd': `Фон`,
's1f2b49c1bca2035d': `Каталонски`,
's1f74bdf32b51a5fc': `Фоново изображение`,
's1f7698c061c208c9': `Отворете`,
's1f8e59d0624842ff': `Каннада`,
's1feab14d837eadb0': `Гуарани`,
's20deffeecf2699fb': `Корсикански`,
's21d61916eb8d137d': `Таблица Тяло`,
's21d723a1dbcd89c8': `Явански`,
's21f8a2eaf5a70749': `Поставяне на етикет`,
's2206c42e5b835e6e': `Маркирайте избора като съкращение`,
's22a2348c46a912a0': `Вмъкване на раздел`,
's233ae776268cd44b': `Бизнес`,
's236ed7ba747099b0': `Тегло на шрифта`,
's2474e7fb1aec9f05': `Тест`,
's2492f5fb1b05b45e': `Текст`,
's24949d7adbb5a098': `Кутия с инструменти`,
's252a52330d32b900': `Метаданни`,
's2540844a4bc4d9ba': `Изискване за приписване?`,
's255857544a9d5ec0': `Нулиране на`,
's255c77900f2b5e0f': `Цветова схема`,
's256ab831a48c941c': `Премахва цялото форматиране на текста от селекцията`,
's2591806d7b222591': `Нулиране на промените`,
's25e1a07e454c2c11': `Мрежа`,
's262abbaf1d05f009': `Мека светлина`,
's266935f2447fcd98': `Над ляво`,
's268ecd1cef45a9a8': `Сигурни ли сте?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Облекчете`,
's27076e66c5d483ba': `Вертикално подравняване`,
's2712dc5641a33226': `Акаунтите за регистър на пакети са предназначени за разработчици и ви позволяват да
          конфигурирате един или повече регистри.`,
's27cc88818cc46ff6': `Стабилен`,
's281d957112b10f12': `Директно редактиране на HTML кода на документа`,
's28b6246ce616a548': `Вмъкване на група колони в таблица`,
's29a1c26521879b9f': `Намаляване на мащаба`,
's29acfd2778e8c377': `Скриване на разширеното форматиране на текста`,
's29b24c06315e9343': `Вмъкване на вход`,
's29eb103449472e3b': `Поставяне на заглавие (ниво 3)`,
's29ee7434494a0dfe': `Вмъкване на заглавие (ниво 2)`,
's29f21c34494d614d': `Вмъкване на заглавие (ниво 1)`,
's29fbfc3449557f72': `Поставяне на заглавие (ниво 6)`,
's29ff743449588131': `Поставяне на заглавие (ниво 5)`,
's2a031834495bcdb4': `Поставяне на заглавие (ниво 4)`,
's2a75c946ef4dcab7': `Различни`,
's2b2ae20d26f78ac2': `Блок`,
's2b8f50c64be440f7': str`Изберете 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Поръчка`,
's2bad2d24def4aa0b': `Прекъсване на реда (CJK lang.)`,
's2ceb11be2290bb1b': `Отмяна на`,
's2ced8e8fafb499f6': `Изтриване на елемент`,
's2d986d31f8d67357': `Вмъкване на набор от полета`,
's2d995a37cf5e4995': `Вмъкване на NoScript`,
's2de969afacdaa7a6': `Форма`,
's2df075aface0dab8': `Споделете`,
's2e192b19ed15fcf6': `Страница`,
's2e39b99cf23606fa': `Задаване на оформлението на избраните елементи`,
's2e4818861000b13f': `Макет`,
's2e66bf8b833858f3': `Уйгур`,
's2e969a451b4955d1': `Маратхи`,
's2eda5288a65bca1d': `Препълване (y)`,
's2edd6688a65e21f0': `Препълване (x)`,
's2f0bcdffc92a786b': `Поплавък вдясно`,
's2f2044f2431a32d5': `Заглавие`,
's2f4d4bfbc466d91f': `Албански`,
's2f8da2cb5f236588': `Името на вашия пакет. Трябва да е с обхват, например \`@org/pkg\`. `,
's30cce87854901922': `Детска градина`,
's3124653c272f054c': `Цвят на правилото за колоната`,
's314a4f7685c8e824': `Винаги`,
's31c06e226322f065': `Избягване на сираци`,
's323dcde72b850272': `Публичен достъп`,
's32911e52ee8ac745': `Поставяне на слот`,
's337a1e9022a8d19f': `Таблица`,
's33c1450d2822bb0f': `Поставяне на надпис на фигура`,
's33c18d5a4cbffa2a': `Ирландски`,
's33f85f24c0f5f008': `Запазете`,
's342b0cabfa672822': `Помогнете на потребителя да намери вашата джаджа`,
's3437e0d9899e7ae1': `Изпращане на телеметрични данни за използването на WebWriter от вас.`,
's344ea8f4939cdc98': `Цвят`,
's34dcda3b0f9d5a98': `Превключване на url`,
's34f724979a124c50': `Задава цвета на фона на избрания текст`,
's355b21b89ce5d9c5': `Подробности`,
's35ae5f4e0fa2777b': `Подравняване по поръчка`,
's35aeaff1425bca9e': `WebWriter не поддържа носители от тип `,
's35c3125c7750681e': `Блокцитат`,
's3643189d1abbb7f4': `Код`,
's3649bacefe731bf6': `Превключване на кутията с инструменти`,
's365280e16a8ea32d': `Копиране на селекцията`,
's366991b9c9287765': `Вдясно`,
's36a194e38d653a26': `Анотиране на данни`,
's36b3cefdcb897f15': `Перспектива`,
's372fae706048ce41': `Четири пъти по малко`,
's377e24af9628c37e': `Поръчан списък`,
's37a8c35f6581da5f': `Без котва`,
's37fa3b9cd51c2dfd': `Задава размера на шрифта на селекцията`,
's380d17664bb69531': `Вмъкване на колона преди`,
's3815184eb09f0dcf': `Курсор`,
's382a2aa3984474dd': `Създаване на`,
's38980f98cb07ceb8': `Записване на активния документ като копие`,
's3914cb410fca44d4': `Внос`,
's3a179f6db2972384': `Позиция на Ruby`,
's3a5ca02f282d247e': `Споделете...`,
's3ae67088bbefba98': `Пакети`,
's3b0ab4b52326316f': `Светлина`,
's3b3ea038c5d3bb06': `Отдел`,
's3bdad99768e11911': `Изследване на`,
's3cb47df8290fa94c': `Вмъкване на опция`,
's3cf89cb47fdde7e9': `Връзка`,
's3d09398e555ee5f9': `Разширени опции`,
's3d249bb480032121': `Списък`,
's3d3efd1e19bdcfb4': `Анотация на дата/час`,
's3d6a732c792ccb9e': `Анотация на Ruby`,
's3d93f9ea0c5a13fa': `Изображение`,
's3d9548e211b958ce': `Пропускане на припокривания`,
's3e092e9d1ee2c5bb': `Клип`,
's3e78ddc9a48a608d': `Доста`,
's3eb6d1e6e79ed7c4': `Не са намерени документи`,
's3eca5a034978754b': `Изтриване на избора`,
's3f06e9abb6ebcb79': `Символи`,
's3f1e7a3f2b283d3b': `Марж`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Гуджарати`,
's3f7e097a9b2e6181': `Вмъкване на статия`,
's3fd83566dd643d10': `Поставяне на легенда`,
's3fe72792941c18f9': `Долна част на текста`,
's3ffcdc5db5e7d0c5': `Обратен`,
's40e3826b7f74a3b5': `Пан (вдясно)`,
's40f07d7859284a44': `Доминираща базова линия`,
's4101ada154a1b958': `Среден`,
's410c465a5993f82d': `Възможност за прекъсване на реда`,
's41322d19c928c603': `ИКТ`,
's417b90913e05bc17': `Преглед`,
's418f2020fe996832': `Потвърждаване на промените`,
's41c724f0698148e9': `Маркиране на избора като клавишна комбинация`,
's41f65a763f8e44ab': `Група за заглавие на таблица`,
's42721130228841b0': `Кутия за удари`,
's429bd646f1cf8bc6': `Акаунтите на Grammar LLM ви позволяват да използвате API на Grammar LLM за коригиране на граматиката в текста.`,
's429dd933ba95549b': `Въвеждане на адрес`,
's42e470ef1d707a28': `Автоматична игра`,
's42ffdab1291fb3de': `Вмъкване на ред след`,
's430831017f3f0499': `Наклонение (y)`,
's430bd5017f42511c': `Наклонение (x)`,
's433ba70286202ceb': `Прекъснете всички`,
's441b20a8a50e36b4': `Македонски`,
's445b8acb9206db6e': `Отхвърляне и отмяна`,
's446a924922651ea0': `Подчертаване на текста`,
's44cdba92713de38e': `Площ на мрежата`,
's45518abd911471d0': `Хърватски`,
's456a8d744313852a': `Пространство около`,
's4634541f5056a546': `Абхазия`,
's46d4abe6255cb9e1': `Повторно задаване на пряк път`,
's4730c232e7209c40': `Подстригване на двете`,
's474f0eec369d02a4': `Примерен изход`,
's47a8f6dfb38b9701': `Телугу`,
's47e257ae643b5851': `Маркиране на избора като анотация за дата/час`,
's47ebf3a8fb3b10c1': `Ориентация`,
's4802bb8eb52fbdeb': `Портал`,
's4802e47fe2e95134': `Опция`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Текстова сянка`,
's4993444bfd3f3e5e': `Свиване`,
's49ad24935b14e3df': `Кечуа`,
's49c560aecfeb8c29': `Маска`,
's49dd67aed00029ef': `Математика`,
's49e763aed00877a8': `Основен`,
's4a894f57eba1cf1e': `Бърз достъп от клавиатурата`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Твърда светлина`,
's4b2c143acf931122': `Височина на линията`,
's4b58c01e2578f5e4': `Легенда`,
's4bbff4e008690da1': `Избягвайте страница`,
's4c1535f316305a2a': `Проверка на избора`,
's4c402ff5355fd310': `Двупосочно превключване`,
's4caed5b7a7e5d89b': `Английски език`,
's4cb38675a21b2c98': `Неподдържан тип на свойството '\${desc.type}' (обработва се като JSON)`,
's4cc8391f172c0cdf': `Отхвърляне на обиколката`,
's4d528b416ac8dee2': `Вмъкване на група заглавия`,
's4d546f6c87128d5b': `Първо пространство`,
's4dcb9315f6527f9c': `Изпълнява се при презареждане`,
's4e191bdb4700a6e9': `Превъртане (x)`,
's4e1c7fdb470386ac': `Превъртане (y)`,
's4e2562fe3990e621': `Грешка при свързването`,
's4e361bf8eef3759a': `Прекъсване на думата`,
's4ea0f21fc2a338a1': `Преместване нагоре`,
's4eace13b3ed74187': `Страничен коментар`,
's4efee5b48a4593cb': `Цикъл`,
's4f26e7cb7c0a8318': `Векторно рисуване`,
's4fd2e638aabb0bb3': `WebWriter поддържа вграждане на много различни източници. Просто поставете връзка
          към съдържание от:`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Тайландски`,
's5015a8fb33b98872': `Тънък`,
's50489ffb1bde152e': `Вмъкване`,
's5068560b8d39663d': `Кликваща карта`,
's517acbf1f96324f9': `Тегло`,
's523eb9043213ff0d': `Курсив`,
's52777d434baeed9b': `Поставяне на индикатор за напредък`,
's52af5d7ac34c2163': `Ред на таблицата`,
's52e0bdc3ee304436': `Поставяне на измервателен уред`,
's531056f039febd39': `Вмъкване на избор`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `Отваряне или затваряне на кутията с инструменти (само на тесни екрани, в противен случай кутията с инструменти винаги се вижда отстрани).`,
's5432ad3c84273229': `Фигура`,
's543906d1db8b2283': `Редактиране на `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Камбоджа`,
's54897f2764b0e4d0': `Инсталирайте този пакет с джаджи`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Отбележете избора като изключително важен`,
's55905c735052d295': `Тематична почивка`,
's5590dbf7e425789d': `Етикет`,
's5623aa2f83b05c76': `Тибетски`,
's564d1648b1ceee9f': `Актуално`,
's565cd5ffb0158c46': `Избягване на региона`,
's571a4f19e2f140c7': `Пан (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Върнете се назад`,
's5787c6d5b3b5541a': `Пътят на клипа`,
's579c69f419b6caef': `Гладка`,
's587ac858dd80f6fa': `Subscript`,
's58bec0ecd4f3ccd4': `Строг`,
's59404f5593c32fdc': `Кернинг на шрифта`,
's5941292bb77281ab': `Норвежки Bokmål`,
's599dcd2472c75c19': `Параграф`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Маркиране на селекцията с анотация на данни`,
's5a356677b61a6b7e': `Молдовски`,
's5b474b5c0ac0c7c4': `Група колони на таблицата`,
's5b517ac216f9ee62': `Встрани`,
's5b8cc9bb61ddce15': `Вмъкване на параграф`,
's5bba2ac2e53bd1fd': `Киргиз`,
's5be80ad6b8301710': `Редовен старт`,
's5c1ecf88259b79f9': `Презентация`,
's5c2a1a52c0389c30': `Инженеринг`,
's5c63af7695445fcf': `Стил на текста`,
's5d18ca4c3111be6f': `Вмъкване на глава на таблица`,
's5d87c1e588f48d90': `Практика`,
's5d929ff1619ac0c9': `Търсене`,
's5da52af9b083c29a': `Модел`,
's5dc77784260a7236': `автоматично`,
's5e27738a2e8eb763': `Влезте`,
's5e2cba97c0d971bd': `Презареждане на пакети`,
's5e53415a6d5719ad': `Социални науки`,
's5e6a7a0c30d2a270': `Пропускане на припокривания (автоматично)`,
's5e9e8e4d21bafedc': `Производство на храни`,
's5ed03bb1f3a15949': `Снимка`,
's5f43af3669b1e098': `Източник:`,
's5feaf7fd7ee567c8': `Дума за прекъсване`,
's600fd23c9ce971e8': `Отпечатване на активния документ`,
's602bbd28dae2c60f': `Самостоятелно стартиране`,
's60ff598dfcf2c773': `Под право`,
's61053f0e3ebbd272': `нормален`,
's613c6ff83883c04f': `Колона на таблицата`,
's6196153c4b0c1ea0': `Инсталиране на`,
's61c017f6d5c303af': `Фризийски`,
's61ded17ca3f48c82': `Отместване на подчертаването`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Избор на копие`,
's624e31cd4f1b89d4': `Гладко превъртане`,
's626daf42b1ab7df7': `Подравняване наляво`,
's6280bf993915c57a': `Марж на превъртане`,
's62b857f5b6693742': `Инупиак`,
's63d894b1ddb06289': `Описание`,
's63dfc5b1c1c27849': `Идиш`,
's63e03c70f67ebf9c': `Контекст`,
's63e71d20d1eaca93': `Немски`,
's640bc7710d0143ce': `Повторно извършване на последната отменена промяна в активния документ`,
's64dc1fc7e3db45c9': `Създаване на нов документ`,
's65ac276544ba33cd': `SVG файл`,
's66765c420ee578e4': `Равномерно пространство`,
's669b18c6d2d9c95b': `Няма`,
's6747dbf4ad6063ba': `Самостоятелен край`,
's6787497df07fa97e': `Може да превъртате над спирките`,
's67c2b60a506a09e4': `Secondary ed.`,
's680bd4d926cd5a84': `Запазване на 3D`,
's6827930ef1aeaf99': `Базов URL адрес`,
's684a16f3c711394d': `Над правото`,
's687e27f036a71b32': `Изолирайте`,
's68b87d7b61052dc3': `Ред на таблицата`,
's68e0e3a2bab7ce3e': `Избягвайте`,
's690da6b432987c6f': `Автоматично архивиране на промените в текущия документ. Промените се възстановяват при презареждане на WebWriter.`,
's69311c4e25074fb3': `Средно училище`,
's697400b541fbc3cd': `Под`,
's6988ab5d47593a26': `Имате най-новата версия на WebWriter.`,
's69a49786a8009f43': `Намерете пакети...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Корица`,
's69fbbdb8ad2a084a': `Потъмняване`,
's6a31eff1ec4f71ad': `Скриване на задната част на лицето (3D)`,
's6ac62e1c8c66f3bb': `Компактен суперскр.`,
's6b585ba37cdb8260': `Наследява`,
's6b61f8abf89586be': `Еврейски`,
's6bd7a02fdf93e653': `Подравняване на съдържанието`,
's6cfc66b824ea05ba': `Ясни ръбове`,
's6d02dc19e21eb49c': `Топ`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Виетнамски`,
's6d8b3b8047ed378d': `Режим на смесване Mix`,
's6d8c02aee480af7a': `Меню`,
's6dadeaaee49d6d18': `Мета`,
's6dfb502188a8c7c2': `Вмъкване на стил`,
's6e288a119281f4c2': `Изобразяване на текст`,
's6e4c20c6debcd5ca': `По поръчка оправдайте`,
's6f84199e62584905': `Предварително форматиран текст`,
's6fb3053e7244d326': `Други полета`,
's70178e04a3b691b6': `Отваряне на настройките`,
's7031ca562378bde6': `Геометрична точност`,
's7060970b5ed20a58': `Интерактивност`,
's7136449045eff28c': `Тамил`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Показване на нестабилни пакети`,
's71dec51005acc1e4': `Плътен ред`,
's72f2a02e2a5a4ee3': `Медии`,
's730182ad28374cda': `Обект`,
's731678e227a20559': `Това устройство`,
's736904f276fbd441': `Природни науки`,
's739544d0c858c633': str`Или да отпадне 
          ${0} тук 
        `,
's73cb20c838e761e1': `Избор на рязане`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Пикселизирани`,
's743f778233e42a3f': `Вмъкнете страничен текст`,
's744d993d03f29851': `Екран`,
's748c0074eff45884': `Манипулация`,
's74aa0039a87141e2': `Елипсис`,
's74b9781bacfcc87c': `Пенджаби`,
's74cd20a7aece9b91': `Попълване на полето`,
's75109f5307578a61': `Добре дошли в WebWriter`,
's75a27f43413e02c5': `Френски`,
's75d83fc3f0cfab40': `Заглавие`,
's762e5704cc84089d': `Задаване на други опции за стил на избраните елементи`,
's77318393dfdb0775': `Премахване на ред`,
's77e594ddcc10c774': `Разрешаване на търговска употреба?`,
's782eac2b3e80323d': `Маркирайте избора като подчертан`,
's782f286a79cca35d': `Относително`,
's78673a3539cb1915': `Горе вляво`,
's78789724e789221c': `Размер`,
's789ff24c8f03f1a4': `Разстояние между буквите`,
's7995733bf97c01cc': `Сръбско-хърватски`,
's7a99528e7b64635a': `Окситански`,
's7aaf0c06e69600f1': `Грешка с `,
's7ae49e142487766c': `Достъп на Общността`,
's7af555180b30a947': `Отворете инструментите за разработчици`,
's7b4ba250601b8667': `Вмъкване на шаблон`,
's7b560d8693ed8f42': `Изправен`,
's7b9994904c4f5b54': `Таджикски`,
's7bdf0fd5b014d36c': `Голямо значение`,
's7beb1e77e82363eb': `Отмяна на последната промяна в активния документ`,
's7c61118554a0ec36': `Максимален (x)`,
's7c95876637f6a9d7': `Филтър`,
's7cb4e55c59663b1c': `Компания`,
's7cfe12cd14df9950': `Отписване`,
's7d27db3c9639c6dd': `Алтернативен`,
's7d8103f6f06f83d6': `Подложка`,
's7d864465dddbb50d': `Разрешаване на промяна на размера`,
's7de0e28d6c309a4e': `Разрешаване на действия с докосване`,
's7dea785045c3cc74': `Натиснете нова клавишна комбинация...`,
's7e0b179d4d1414eb': `Въведете връзка`,
's7e6570f2f1ae320f': `Синтезиране на шрифтове`,
's7ecb1f29332293e5': `Базова линия на привеждане в съответствие`,
's7ed13ccddb1bf3c3': `Покритие`,
's7edbe0b213199995': `Бакалавърска степен`,
's7ede1c55e35ce9d6': `Симулация`,
's7f09197a4814079b': `Задаване на опции за интерактивност за избрани елементи`,
's7f326a142e856656': `Стил`,
's7fcb35d23be1e643': `Набор от полета`,
's80570196a9ce6d11': `Активиране на телеметрията`,
's806f84eb0ace116e': `Вижте какво сте избрали и го променете. Копирайте, изрязвайте, поставяйте, закачайте или правете промени в оформлението. Предлага различни опции в зависимост от избора ви, напр. форматиране на текст.`,
's80a42b81c52d4d8f': `Цвят на каретата`,
's80b71fc6f43c5ce1': `Свободен`,
's812cbda653daaeba': `Тази функция все още не е въведена`,
's814d528c8af55807': `Елемент от списъка с определения`,
's81c3d8809658b951': `Кашмири`,
's81cf65c5a46dea08': `Киняруанда`,
's81ecf2d4386b8e84': `Продължи`,
's8247d32213e35f24': `Вмъкване на основен`,
's82665b2ffabc9c0a': `Уебсайт`,
's828b1ecea8715884': `Панел (отляво)`,
's833bd0422a7ef95d': `Размер на разделите`,
's83420ad7b6a14db5': `Превключване на инструментите на Dev`,
's83c15613b6f6f3c8': `Само онлайн`,
's83cd32b685ccc9b7': `Контроли`,
's83f26d02dd7aa681': `Видими`,
's840fa49e8989c028': `Позиция/форма`,
's844a76d1843ceb3c': `Възстановяване на настройките по подразбиране`,
's84e4e8ae645b82ac': `Горе вдясно (y)`,
's84e9c7f8785ca60b': `Вмъкване на формуляр`,
's8517ae4da104b004': `Група колони на таблицата`,
's85186a61e0d55bac': `Видео`,
's851a7deea5984646': `Лиценз като Creative Commons OER?`,
's85f9aa6d3ea0e421': `Група за колонтитул на таблицата`,
's864b0e6270e97246': `Маркирайте избора като страничен коментар`,
's8670e5ad3bf0dcf8': `Запазване като`,
's8688d74dd3716d6e': `Клавиатурни комбинации за команди`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Марж на формата`,
's87cefc710b3567fb': `Съдържат`,
's88676f992b2965db': `Разтягане на съдържанието на клетките`,
's886897f2fd4edb99': `Скрит`,
's886c5db2a5579873': `Концепция`,
's888c71e8fcb916d3': `Автоматично запазване`,
's88a62d29529948fb': `Вмъкване на таблица`,
's89950d86c8004d4b': `Пропускане без припокриване`,
's89bca7498f20e041': `Клип за фон`,
's8a28bad9290d4761': `Оромо`,
's8a29cb39a42f83f3': `Прекъсване преди`,
's8a4ff2bd9c13498c': `Запис`,
's8a6585c48ea104e9': `Скриване на празни клетки`,
's8a9eb438abac7c6a': `Етикети`,
's8b0432eecbd8b034': `Актуализация`,
's8b7580c35e2aef87': `Горен ляв ъгъл (y)`,
's8bc4affa761aa8a2': `Вмъкване на изображение`,
's8c7f51cb067644c7': `Списък с данни`,
's8d342ecaa9e75b9b': `Връзка`,
's8d797888455f4147': `Помещения за почивка`,
's8d83386457e91813': `Отменяйте/поправяйте промените си или преглеждайте от гледната точка на обучаемия.`,
's8d8643013a7754d1': `Подравняване на текста`,
's8df30fe2a50d3479': `Вмъкване на възможност за прекъсване на реда`,
's8e715248c3a78446': `Изрязване на селекцията`,
's8f29e48d6b9a1aa8': `Вмъкване на ред за заглавие на таблица`,
's8f4be9f086eb530f': `Отмяна на`,
's8f533296a536965e': `Запази като...`,
's8fad58c831ecf017': `Контейнер за текст Ruby`,
's8ffe7abcbed8eb43': `Вертикално, отляво надясно`,
's90105521fcc40453': `Акаунтите в WebWriter Cloud ви позволяват да съхранявате документи онлайн и да ги
          споделяте с учениците си. Добавете акаунт тук и той ще бъде достъпен като място за
          запазване, зареждане, споделяне и отваряне на документи.`,
's9095f01a80a91594': `Супер`,
's90f0fbc12e1e2b2f': `Палитра с шрифтове`,
's90f7c1cf501ea0a7': `Цвят избягване`,
's91093e0b087911ba': `Позиция за подчертаване`,
's919e1724f589c9b1': `Слот`,
's91c5ed7769d00b65': `Вмъкване на вграждане`,
's9219acd5bef6269e': `Под ляво`,
's92548405912d46bf': `Подравняване на приплъзване (y)`,
's9258280591309342': `Подравняване на скрола (x)`,
's927d796559f49439': `Предистория Произход`,
's92b177e579ef7b97': `Акцент`,
's92f846b9be2e8e8d': `Маркирайте селекцията като курсивна`,
's93566b84230af4f5': `Вмъкване на снимка`,
's936aa0b239679585': `Вмъкване на тематична пауза (обикновено се показва като хоризонтална линия)`,
's9370dc6afa716b57': `Граница`,
's93f083e654a45715': `Бретон`,
's94653c76b2d86a04': `Определен срок`,
's9485af2e7cd9418f': `Начално училище`,
's94d2eee44b292567': `Превключване на разширените опции`,
's94d61907ee22a8c1': `Корейски`,
's94eb1effbbb6498b': `Преливане`,
's951aa3a6439f1271': `Маркер на списъка`,
's9565553d163fc92a': `Скрипт`,
's957787fc6b7ea5c0': `Пан (нагоре)`,
's95c161f68e5180a5': `Проверка на избора`,
's95d56e58f816d211': `Холандски`,
's95d8e41a64635c7c': `Бяло пространство`,
's95de7e1eff6c053e': `Хоризонтално, отгоре надолу`,
's960d3a90ac199368': `Рето-румънски`,
's96532132a29dd542': `Вмъкване на аудио`,
's96a045dcade75ad0': `Плътна колона`,
's9781a5bb3fcb26a3': `Изберете първо компания`,
's978522fbc9577a7e': `Сомалийски`,
's97881699a2b21d5b': `Разлика между редовете`,
's97aa76056a81bd36': `Метрики`,
's986facb3ecc9602c': `Встрани, отдясно наляво`,
's987abd19fac8cf55': `Под`,
's9896529e5cb20558': `Външен файл`,
's98977a87d1b93941': `Нулиране на информация, стилове и скриптове`,
's990d0e0fa2ab00b5': `Галисийски`,
's99229574e5692f19': `Гренландски`,
's99a990f3841ad283': `Файлове на `,
's99b38e000175cc84': `Зачеркване`,
's99f110d27e30b289': `Заглавие`,
's9ab10fbf4c7a7322': `Позиция на подчертаване`,
's9abadcc828884d7b': `Текстова област`,
's9b7cd8860c8fc922': str`
          ${0}
          ще бъдат презаписани. Сигурни ли сте? 
        `,
's9c11f2d9335d8bd1': `Ория`,
's9c356016f81585f6': `Цвят на фона`,
's9c8df9626d152d5a': `Списък с определения Термин`,
's9ca757effd747da9': `Урду`,
's9caf10388ab3562f': `Колона на таблицата`,
's9cf68f87b8e6122f': `Азербайджански`,
's9d167ef77aed79b6': `Слой`,
's9d2d00982edafabb': `Турски`,
's9d430adc5be110e9': `Обратен ред`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Интерлингва`,
's9d668a34af4128ff': `Изтриване`,
's9df571714a1efb44': `Налична е автоматично запазена версия на това изследване. Да я заредите?`,
's9e28faa598332e2b': `Вмъкване на видеоклип`,
's9e3dbb678150edd4': `Задаване на семейство шрифтове`,
's9e40e59654c8ad67': `Колона`,
's9e85800d3700e31c': `Проследяване`,
's9e8d3665edde89a6': `Науру`,
's9eefe6e57e4e1661': `Вариант на шрифта`,
's9f1ecdb3061d9cbc': `Запазване на пространства`,
's9faf26107ed49fb9': `Вмъкване на клетка от таблица`,
's9fbe26cfd7845469': `Хауса`,
's9fc686f7bbd941e2': `Преход`,
's9ff3121d30f88d52': `Нормален`,
's9ffe1bbe64712bf1': `Платно`,
'sa00df4e39c72d3b4': str`
          ${0} не се поддържа 
        `,
'sa013e119fec906fb': `Ред`,
'sa01e7bf33563ef72': `Връзка с предишна информация`,
'sa126cf8c627cec1e': `Визуализиране на изображения`,
'sa13f72278add7513': `Под право`,
'sa1647e3b36ec08d7': `Комбинирайте изправен`,
'sa172190ea21f9b1c': `Достъпете до настройките, отворете изследователска зона или създайте нова.`,
'sa1c6c459b9b5115c': `Абсолютен`,
'sa2cba871f6cdd99f': `Асамски`,
'sa2eff4dad1c119f1': `Шаблон на мрежата`,
'sa30c12014e955946': `Руски`,
'sa30f1981fd1cd441': `Размер на шрифта`,
'sa311a24c1471a974': `Документ`,
'sa352d168b262aa06': `Поставяне на колонтитул`,
'sa37fee6a52d18063': `Изтриване на документ`,
'sa39c7ac1d37f3bce': `Маркирайте селекцията като "двупосочна изолация".`,
'sa3b4c01623211544': `Сила`,
'sa40fd43756fa8913': `Персийски`,
'sa417644bef21a9aa': `Неназована тема`,
'sa43800e28be1bdbc': `Цвят на декорацията`,
'sa477cb1825dceb3b': `Судан`,
'sa492a51a707930fa': `Вмъкване на блоков цитат`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Надпис в долната част`,
'sa50d3c35533f1d99': `Всички полета`,
'sa53c5cb03a8fda50': `Прикрепете селекцията като фрагмент в палитрата`,
'sa557ae6bee9148a6': `Прогрес`,
'sa589e1df65dde0ec': `Задаване на размера, подложката и полетата на избраните елементи`,
'sa5c371b4bb75e590': `Вляво`,
'sa5c80e623459ffe4': `Поставяне на заглавие`,
'sa5df1bcdba46c3fb': `Фигура Заглавие`,
'sa602e3fd3f2d98fd': `Анимация`,
'sa644d580d8a11e60': `Подравняване на Ruby`,
'sa645d315510dc09e': `Изберете път от диска`,
'sa65d4ad99f1d8c06': `Задаване на фонов текст`,
'sa6607436f60ccc1a': `Естонски`,
'sa6f8d27bca557059': `Преместване на елементи мета/връзки/стил нагоре/надолу в този елемент`,
'sa757645ad842da97': `Запазване на почивките`,
'sa75b95980cd80e78': `Редактор`,
'sa7698b3d20a6d1ec': `Скрол`,
'sa778acc33947c7b8': `Завършване на обиколката`,
'sa78a67272a4a6f95': `Математическа формула`,
'sa79167651dce1e80': `Алтернативен текст`,
'sa7af797a46c7d09a': `Футер на таблицата`,
'sa7dbe35b758c138d': `Вмъкване на платно`,
'sa7dc6b8ef3f595dc': `Вмъкване на източник`,
'sa8279f8211b3950d': `Запазване на почивките и пространствата`,
'sa8b55cab62e439b5': `Премахване на колона`,
'sa8bbe0197d31b423': `Кратко описание`,
'sa9ff3b762365abe6': `Начало на трансформацията (z)`,
'saa02e3762368ff35': `Начало на трансформацията (y)`,
'saa065776236bfa28': `Начало на трансформацията (x)`,
'saa33768e03c45fc8': `Размер на файла`,
'saaad98061a20ac39': `Вмъкване на математическа формула`,
'saab875d8cfcfe712': `Тема`,
'saad4380b9cc6cefd': `Алтернатива над`,
'saaec15c97a9e4245': `Обратен ход на колоната`,
'sab0c57df694a0a09': `Начало на подстригване`,
'sab4d9283896d9422': `Пиксели за разделителна способност на снимките`,
'sab55faae8e165407': `Запълване&lt;br&gt; като разстояние`,
'sab5e7d2a069a2951': `Професионален сертификат.`,
'sab726d2db7e6b93d': `Кирунди`,
'sac687b8649989de8': `Подравняване надясно`,
'sac895c732f350ac5': `Dark`,
'saced41ddda8b2354': `Гъвкава основа`,
'sad190f86451081c0': `Непалски`,
'sad6be321164d08c8': `Компактна математика`,
'sadd352cc7f6f2307': `Настрана`,
'sae098810f946ca7c': `Тагалог`,
'sae185e6af80ec81e': `Шведски`,
'sae1c7f13b7c0c47f': `Начало`,
'sae76e25497dcee58': `Ректо`,
'sae9c790b88be7eb9': `Маори`,
'sae9d739068eee2c5': `Татарски`,
'saf312eaeec77a802': `Вмъкване на списък с описания (речник, списък с термини)`,
'saf3da7c95cb17260': `Маркирайте селекцията като надпис`,
'saf440a0a592f2835': `Актуализация до`,
'saf9e5134ba1a7d30': `Свиване snap`,
'safc6f203342d09e2': `Превключва визуализацията на активния документ`,
'sb0a7e3adf4a125ee': `Горе вдясно`,
'sb0a974028c99ca6d': `Позволяват ли се адаптации?`,
'sb0d4f0f7993cf085': `Задаване на размера на шрифта`,
'sb0f3327210fe18fc': `Колони`,
'sb0f93c1c60c0249a': `Рубинова база`,
'sb1494c08c8c720d1': `Задаване на цвят на текста`,
'sb19611adbc88f711': `Напреднали: Показване на команди за редактиране на източника, например за показване на HTML на документа или за добавяне на персонализирани стилове и скриптове.`,
'sb206d700d26b14ff': `Подчертаване`,
'sb233557012dcb328': `Преместване надолу`,
'sb26035b596566abf': `Неназован`,
'sb2cda80610c8d6ea': `Пространство всички`,
'sb2dc787b0983ebc6': `Литовски`,
'sb31cdff08b1c5a50': `Синди`,
'sb38d497d992ab4a4': `Център`,
'sb3ba3276ae93627c': `Вмъкване на предварително форматиран текстов блок`,
'sb430f5b4824de0d3': `Изберете оформление`,
'sb43db07b24da018a': `Амхарски`,
'sb45f9fb4dba6e71a': `Ненастроени`,
'sb4e003a459464d85': `Кюрдски`,
'sb4f0310e6787d098': `Узбекистан`,
'sb4f1dffbb6be6302': `Clear`,
'sb51270e19988f9bd': `Регион`,
'sb59d621e3c93cc27': `Споделени граници на клетките`,
'sb5e9e1776242b028': `Взаимодействия`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Докторска степен`,
'sb6103872073d369e': `Вмъкнете подробности`,
'sb616811735bfbafd': `Клетка на таблицата`,
'sb628960829e223bb': `Пропускане на всички припокривания`,
'sb6434faf698b02a2': `Шона`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Прилагане и внос`,
'sb66e2181a7b5738a': `С активирането на телеметрията разрешавате събирането и съхранението на данни в съответствие с нашите`,
'sb67e0e7c0869f982': `Разлика`,
'sb68e83cda6c85af8': `Заглавие на таблицата`,
'sb6b268120592dc53': `Хинди`,
'sb6ca0a8bb3caae69': `Дебелина на декорацията`,
'sb70c17f7899f9b01': `Латинска`,
'sb71941f552f3504d': `Задаване на специална стойност`,
'sb740eab4afd5a710': `Автоматичен поток на мрежата`,
'sb741b6e0ca589122': `Връщане на слоя`,
'sb7c77d0415de05cf': `Извършване на тестове`,
'sb7fb7568f6883ab8': `Споделяне на активния документ`,
'sb85774dc5d18ff0f': `Потвърдете`,
'sb85b1e36579852a6': `Невалиден имейл или парола`,
'sb884fa76bfc55429': `Арабски език`,
'sb8a3d4df7d1c5e6b': `Баланс`,
'sb8f610a0e8df91fc': `Светлинност`,
'sb8f855b49234b81b': `Направете заявка на`,
'sb905da066c10182c': `Плюс по-тъмно`,
'sb940ade1bd81be7e': `Под ляво`,
'sb9e9a7dd45966756': `Маркирайте избора като удебелен`,
'sba509fd8ed61d1d5': `Незаписан файл`,
'sba64d8954d027206': `Прозрачност`,
'sba88d90cd6c751b3': `Правило за колоната`,
'sbaf0a7c417e388af': `Здраве`,
'sbb15d427ee1aa676': `Тигриня`,
'sbb34f2e3aa40af4e': `Тонга`,
'sbb55f9f2d69fd327': `Филтър за фон`,
'sbb85a407d730e13d': `Вмъкване на търсене`,
'sbb86c6c96f598bb8': `Смесени`,
'sbba0156f795d8c07': `Редактиране на избора`,
'sbba865d4b437944f': `Атрибут`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Деинсталиране на`,
'sbc5f2a81604baf9b': `Позиция 6`,
'sbc5f2b81604bb14e': `Позиция 5`,
'sbc5f2c81604bb301': `Позиция 4`,
'sbc5f2d81604bb4b4': `Позиция 3`,
'sbc5f2e81604bb667': `Позиция 2`,
'sbc6953a36ced943f': `Политика за поверителност`,
'sbd181cd54b8402a4': `Редактиране на избора`,
'sbd35ee879d9cf770': `Текст на Ruby`,
'sbd40f40cbadd38d5': `Премахване на този пакет от джаджи`,
'sbd72dc858de95ce8': `Бирмански`,
'sbe3c60c65f129daa': `Хуманитарни науки`,
'sbe4a7c8f231739b3': `или поставяне/пускане/избиране на файл`,
'sbe90de083557ef3e': `Суахили`,
'sbefb6064cba01844': `Поставяне на прекъсване на реда`,
'sbf00e1ee999ea94e': `Вмъкване на скрипт`,
'sbf519920c2017d67': `Окачване`,
'sbfa01f189a68d3e9': `Увеличаване на гъвкавостта`,
'sbff54e740c4086eb': `Показване на неизвестни пакети`,
'sbfff51feacf30196': `Санскрит`,
'sc0ceaa9843510f67': `Туркменистан`,
'sc1611c0558728a2a': `Позиция`,
'sc1a155cc25899250': `Група редове на таблицата`,
'sc1aa1f6051b7102a': `Румънски`,
'sc1edebeaef92b7bd': `Фиксирано оформление на таблицата`,
'sc1fff4f356dfb2fb': `Преобразуване`,
'sc24bda3c061fddf8': `Област с възможност за кликване`,
'sc252a4e091763606': `Вмъкване на колонтитул на таблица`,
'sc2536e077514accc': `Превъртане`,
'sc275dd00036d16cb': `Характер на цитатите`,
'sc28864200d2a3799': `Копиране на QR кода като изображение`,
'sc2a24a9dd41a9503': `Линия за декорация`,
'sc2b734cca2fa643b': `Пан (надолу)`,
'sc2e2a0dbf03723b7': `Напреднали: Показване на пакети от неизвестни източници в мениджъра на пакети (Предупреждение: Може да е опасно)`,
'sc3998b77d72c2932': `Вмъкване на уебсайт (като вградена рамка)`,
'sc3ac225273c8316b': `Обща информация`,
'sc3cfee84dbbf36ae': `Местен файл`,
'sc3f09a9b6fa4fbed': `Отвътре`,
'sc43767deea72e9f3': `Списък с описание`,
'sc462bbdd36bcba6b': `Референтна кутия`,
'sc4ee3e4ee994dafd': `Украински`,
'sc50d09edf9325339': `Диалог`,
'sc52b67794c06a0d3': `Начало на перспективата (y)`,
'sc52e8b794c0913d6': `Начало на перспективата (x)`,
'sc53de149fcaad713': `Междусимволна връзка`,
'sc546f489f9c0cced': `Превключва режима на изпитване на активния документ`,
'sc5bcf50d1b578d9f': `Настройки на функцията за шрифт`,
'sc5cb39478b9b7625': `Маркирайте селекцията като индекс`,
'sc6415b50ff928294': `Позиция от списъка`,
'sc650ff15b20fe9d3': `Завъртане (z)`,
'sc6578b15b2154365': `Завъртане (x)`,
'sc65aff15b2183e58': `Завъртане (y)`,
'sc6da0f4a7e4d710e': `Замяна на езика на шрифта`,
'sc74e3567875ce255': `Както тагът на вашата джаджа, така и името на вашия пакет NPM`,
'sc7eb080b96e244df': `Малайски`,
'sc8ac7ef92b95df3f': `Преместване (x)`,
'sc8af536e2084ade0': `Палитра`,
'sc8b022f92b992bc2': `Преместване (y)`,
'sc8b39af92b9c2d81': `Преместване (z)`,
'sc8d2c7f6c33a2b32': `Задаване на стил на текста (подравняване, отстъп, разстояние и др.) на избраните
          елементи`,
'sc8fa0e3de389ef1c': `Регулиране на размера на шрифта`,
'sc9474bf7a0668d73': `Резюме`,
'sc94e314312a8900c': `Чешки`,
'sc980855a000b76ea': `Дъно`,
'sc98b103772de63f4': `Финландски`,
'sca7cfe2bef51b2a5': `Корен`,
'sca7fed2bef53cb99': `Роля`,
'scabe6ecee5e01fd2': `Малтийски`,
'scace301a88231cce': `Вграждане`,
'scbc55f622ec078c1': `Преглед на кутията`,
'scbe537fc38ff4c13': `Автоматични колони на решетката`,
'scc1db59d292cbc4c': `Раздел`,
'scc56b218a2689c42': `Арменски`,
'scc5ba32e0de06744': `Сезото`,
'scd15088c39fe9edf': `Кутия за подплънки`,
'scd9cedeb5ece3adb': `Хифенни думи`,
'scdf536b65be39ec5': ` Създаване/импорт`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Идеографски`,
'sceecdd0bb404bc17': `Вмъкване на група опции`,
'scf00d48fd5953a03': `Гръцки`,
'scf932840a69dbb7c': `Португалски`,
'scf932a8577057752': `Футер`,
'scf95dcb12a950a5c': `Аймара`,
'scfcb70f2a15eaf14': `Долен десен ъгъл`,
'sd01178c54f648118': `Колони за баланс`,
'sd03bff50f87f82d4': `Знак с тирета`,
'sd05a155fe09c2866': `Онлайн, когато използвате`,
'sd0864ea6cb6ef22e': `Общност`,
'sd10fdbe6caf9a998': `Прекъсване на реда`,
'sd121d3b959b7888d': `Оптимизиране на скоростта`,
'sd1a78e667a1a139f': `Маркиране на избора като вмъкване`,
'sd1cffad290ea5b3b': `Запазете всички`,
'sd1f10284eeb17b25': `Фиджи`,
'sd1f44f1a8bc20e67': `Имейл`,
'sd1f81984eeb7c0e8': `Напълнете`,
'sd29dc07235eea0f5': `Котировка`,
'sd2addf69477cd4b4': `Внос на пакет`,
'sd2ed26defc646d47': `Филтър за фон`,
'sd2ef82b8ea877c6d': `Африканс`,
'sd319aae1401f1e19': `Фиксиран`,
'sd3a288c1094b8a63': `Ширина на правилото за колона`,
'sd3c65ef5c380c046': `Вмъкване на`,
'sd3dcb76f7b28adb8': `Латвийски`,
'sd3eca1e0f4209f6e': `Подрязване на всички`,
'sd3f402df8619ddcd': `Тази информация за вас се добавя автоматично към новите документи. Можете да я
          промените за всеки документ в редактора на метаданни.`,
'sd4368b12645d3c0f': `Вмъкване на портал`,
'sd452cebf4a0313d1': `Показване на командите за редактиране на източника`,
'sd48cc52117f4d68b': `Италиански`,
'sd52660ee947ca58b': `Вмъкване на колона в таблица`,
'sd588d17a1b25c220': `Преливане на текст`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Висше образование.`,
'sd5cf95145e4d89ca': `Откачете този фрагмент`,
'sd5fd9d11a92f5b1d': `Долен ляв ъгъл (y)`,
'sd60c9bbc51375635': `Вмъкване на бутон`,
'sd66c4767fa3dde28': `Акцентен цвят`,
'sd679c8b1bf8cc8a5': `Малки капитали`,
'sd7086c4425c53c80': `Семейство шрифтове`,
'sd837f42ac7cbfb58': `Форма (отвън)`,
'sd88076d2994ee0fb': `Изключване`,
'sd89a2e529b31ef43': `Върнете`,
'sd8a345e95668b73b': `Вертикално, отдясно наляво`,
'sd8ce9e57270b030d': `Разтягане на шрифта`,
'sd8ecf227c7c49331': `Математически`,
'sd8f923198e0c5c6a': `Край на`,
'sd9c21e5f60d6bdd8': `Датски`,
'sd9ff8e2612e63d50': `Оразмеряване на полето на границата`,
'sda2d76b976502a8d': `Отворено...`,
'sda344aacb837387e': `Позиция в контейнера`,
'sda5b6fa8b771f996': `Поплавък наляво`,
'sda9254d1f1228e1a': `Унгарски`,
'sdb1595f5c742dfbb': `Вход`,
'sdb711380a28fec75': `Вмъкване на списък (подреден)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Долен десен ъгъл (y)`,
'sdc48456f9a27ae02': `Генератор`,
'sdc70d81cf6c28533': `Грузински`,
'sdd1ff479d04ac140': `Публичен`,
'sdd2fc8919a9c3111': `Режим на смесване на фона`,
'sdd35b688281b6dea': `Японски`,
'sddc49047f66a64ab': `Няма предоставено описание`,
'sdef34fe08bb28b09': `Китайски (опростен)`,
'sdf62e305e1594805': `Маркиране на селекцията с анотация на Ruby`,
'sdf946172dfa0328f': `Суперскрипт`,
'sdf9bc5d9b7f3e3de': `Изравняване`,
'se036b53f145441cd': `Смесено съдържание`,
'se06f459fccdc3ce9': `Изравняване на последния ред на текста`,
'se0a782a8be8e018b': `Норвежки`,
'se0cda6b80a1bb50f': `Словашки`,
'se0f67eae944f8f94': `Заглушаване на звука`,
'se1312d6528f9a259': `Йоруба`,
'se16c5e66886fbc59': `Статия`,
'se1f5bb0386c88f96': `Задава цвета на избрания текст`,
'se219da7b1e955c65': `Ясно форматиране`,
'se25e4f2cb77b8be8': `Език за интерфейса WebWriter и нови документи`,
'se2796c5824ec8916': `Видимост на съдържанието`,
'se308836a594808b6': `Сингалски`,
'se36c5b1baf5e0660': `Навсякъде`,
'se39c065efa467782': `Баски`,
'se3b4c857f91f80d7': `Клавиатурни комбинации`,
'se47baf2fd16b9d2b': `Шаблон`,
'se48bd9e6c2a3109d': `Сметки`,
'se58467472725ad0c': `Резолюция на изображението`,
'se58f06c2b0583ff7': `Изберете координати`,
'se5dc1e97fb743ade': `Разстояние`,
'se619a501d1bfe6a5': `Обвиване`,
'se62385ac082368d2': `Маркирайте избора като източник на цитат`,
'se6297163cac9d276': `Редактиране на източника`,
'se633223a0b88625e': `Разполагане на клетките`,
'se638417c560cfe5c': `Пробив вътре`,
'se64f418b4e733b6c': `Вмъкване на изход`,
'se6cdad455e2d8c02': `Поставяне на деление`,
'se79c0a3ac70d8fb3': `Коефициент на аспирация (x)`,
'se79fae3ac710dc36': `Коефициент на аспирация (y)`,
'se7fad370d8fb4cec': `Оптимизиране на четливостта`,
'se8a94b4effa2033e': `Азбучен`,
'se95d4e55ea186d9a': `Цвят на лентата за превъртане`,
'se96d43a515b8451c': `Словенски`,
'se96fd76ba1b2975a': `Централен`,
'se9ac05f36b004eb0': `Скрийте встъпителната обиколка. Деактивирайте, така че обиколката да се покаже отново.`,
'se9b1fec72ffd8f48': `Местни`,
'sea24bdcaa2bd2dec': `Задължително щракване`,
'sea52df2b70a5c10d': `Руби`,
'sea6e7291e27ec53f': `Превключва редактора на метаданни`,
'sea896ed51ad33287': `Няма налични специфични стилове`,
'seaaaeb09e3b4e78b': `Команди за редактиране`,
'seabae79729c4b2ad': `Превключване на имейл`,
'seaecc8267bad6234': `Средно училище`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `Избягване на колона`,
'seb4e52ef5ec7a7dc': `Цветове/ефекти`,
'seb8982ae8c3cdcc5': `Индонезийски`,
'sebbced89e0db2894': `Първа базова линия`,
'sec02109a0dd2a6c8': `Подчертан цвят`,
'sec2557a35b702525': `Променлива`,
'sec2da4aa7a02b925': `Исландски`,
'sec30fbb20f102670': `Вмъкнете резюме`,
'sec8b0b6c729816b6': `Група заглавия`,
'seccd05955adb76bc': `Плакат`,
'sed17285cd25d6389': `Директория, в която се намира package.json`,
'sed318ec045c5144f': `Над`,
'sed713f1b916fb469': `Разстояние между границите (x)`,
'sed74a31b9172942c': `Разстояние между границите (y)`,
'sed86bd0deb2e5372': `Трансформиране на текст`,
'see2fcaedf9743ec6': `Местоположение`,
'seec6798afe90ffc8': `Отпечатване`,
'sef00c258bc1ecf1e': `Това проучване има неспасени промени.`,
'sef23dd271edd4a8b': `Долен ляв ъгъл`,
'sef24caccbd4645ef': `Гъвкаво свиване`,
'sef49aec68fd1dc66': `Име`,
'sef73fe18e351eb35': `Ключови думи`,
'sef75f458d77491af': `Група опции`,
'sefcf950b3cc4fc3b': `Език`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Съдържание`,
'sf0cab2483f66aa2e': `Потребителски`,
'sf0e261e04eda82ff': `Външен вид`,
'sf1045382c1fd9a85': `Точни цветове за печат`,
'sf14c35392ec7bf10': `Тази функция не е налична във Firefox. Тя е налична в Chrome или Edge.`,
'sf14f9d5f9f6ca342': `Плюс по-лека`,
'sf1868dc19e3917bb': `Испански`,
'sf190149f9d8bbb2a': `Режим на писане`,
'sf1e79171c4856543': `Сигурни ли сте? Това действие не може да бъде отменено, всички ваши настройки ще
          бъдат изтрити и нулирани.`,
'sf21c1f60c7515f44': `Маркирайте избора като извадка`,
'sf21fb4f4b9e8911f': `Ширина`,
'sf22a3737146ec910': `WebWriter може да вгражда SVG директно в документа.`,
'sf2514d5dc78b1654': `Вмъкване на джаджа`,
'sf28903d4ca0ddcfc': `Премахване на този акаунт`,
'sf2ab37af0abc55ef': `Скрийте интро обиколка`,
'sf2bdb0b4d7b9c039': `Бенгалски`,
'sf2cbb5e519264e67': `Промяна на размера по хоризонтала и вертикала`,
'sf2d5cbc2fe0ad65a': `Залепващ`,
'sf2d96d0eb32cb81f': `Анимационен състав`,
'sf2de3dbe2108637a': `Изобразяване на формата`,
'sf2e08a945e9194d4': `Уелч`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Вмъкване на песен`,
'sf3c4da68b08a2590': `Мадагаскар`,
'sf471ec2496f904cc': `Отхвърляне на промените`,
'sf4849bc200e279ed': `Заглавие на таблицата`,
'sf486ca1fdbe08645': `Поставяне на фигура`,
'sf4b537d4cbd8f5fd': `Връх на текста`,
'sf4e0e02a5277ef23': `Вмъкване на текстова област`,
'sf4f067d41efd4b83': `Мащаб (y)`,
'sf4f3cbd41f002b46': `Мащаб (x)`,
'sf4fa67d41f05a008': `Мащаб (z)`,
'sf5197db2d5f2926a': `Завъртете`,
'sf52d840949a980d1': str`
          ${0}
          ще бъдат изтрити завинаги. Сигурни ли сте? 
        `,
'sf55d634dcc743595': `Услуги`,
'sf59c9081d106dd9c': `Маркирайте селекцията като променлива`,
'sf5e76f774beb33c2': `Инуктитут`,
'sf64a8229a8136552': `Изтриване на документ`,
'sf65df67a03bebe4b': `Задължително за тази джаджа`,
'sf6673729c03ae999': `Нулиране на WebWriter`,
'sf67571992e7dc88e': `Пълен срок`,
'sf6b4934598f7ed10': `Разрешаване на избора`,
'sf6e1665c7022a1f8': `Парола`,
'sf79e0d78b56444f1': `Вграден край`,
'sf7a5f7a7c80c3082': `И двата сайта`,
'sf7c0eba7c822e3d6': `Bold`,
'sf86bd4d2982f3b74': `Маркирайте избора като код`,
'sf8e82313fa411494': `Маркиране на избора като връзка`,
'sf955eff73fb6b573': `Сръбски`,
'sf9929e2d356260c5': `Умножете`,
'sf993bb199fefbe04': `Всички`,
'sf9ecf969dd4b8164': `Двата ръба`,
'sf9f2c719a04066ec': `Приложение`,
'sfa49a5bb1a5d353e': `Частен достъп`,
'sfa59c7777e2a0eeb': `Вмъкване на списък с данни`,
'sfaa0a67db5c11f72': `Отстъпване на първия ред на текста`,
'sfb231a52211b133f': `Без обвивка на текста`,
'sfb68cae41d749423': `Първоначален`,
'sfb9b6edb0ed378c9': `Източник на цитиране`,
'sfbbab09dbe553571': `Вмъкване на векторна рисунка (SVG)`,
'sfc00292e778b67e2': `Измервателен уред`,
'sfc63e31ac7c956ed': `Изберете`,
'sfc815c9078bba30a': `Изтегляне на QR код като изображение`,
'sfcdd8e672c75b713': `Адрес`,
'sfcebd18506f1e535': `Поток`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Изход`,
'sfdb1e4d90981a535': `Споделяне на този документ`,
'sfdeef3dccf409f81': `Тази ключова дума е задължителна за джаджите`,
'sfe6e758ad2603c1d': `Магистърска степен`,
'sfee1c12daf838935': `Цвят на изгаряне`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Вмъкване на диалогов прозорец`,
'sffa395f64ec6ac36': `Български`,
'sffdadf0a576fd802': `Височина`,
'spaceKey': `Space`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Нагоре`,
's2739460e44320108': `Chinese (Traditional)`,
'scbf29ce484222325': ``,
    };
  